import { render, staticRenderFns } from "./PlayerTutorialView.vue?vue&type=template&id=3f5c849b&"
import script from "./PlayerTutorialView.vue?vue&type=script&lang=js&"
export * from "./PlayerTutorialView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports